const PolicySkeletonCard = () => {
    return (
      <div className="animate-pulse bg-white rounded-xl shadow-sm space-y-6 border border-gray-200 py-10">
        {/* (Icon + Name) */}
        <div className="flex items-center gap-4 lg:px-40 px-10 py-5">
          <div className="w-48 h-32 bg-gray-200 rounded-md"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
            <div className="h-4 bg-gray-200 rounded w-3/5"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
  
        {/* Attention Message */}
        <div className="h-10 bg-gray-300 w-full"></div>

        <div className="border border-gray-200 mx-10 p-4 rounded-lg space-y-3">
          <div className="flex items-start gap-4">
            <div className="h-6 w-6 bg-gray-300 rounded"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
  
          <div className="flex items-start gap-4">
            <div className="h-6 w-6 bg-gray-300 rounded"></div>
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        </div>
  
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 mx-10">
          <div className="h-10 bg-gray-300 rounded w-full sm:w-1/2"></div>
          <div className="h-10 bg-gray-300 rounded w-full sm:w-1/2"></div>
        </div>
  
        {/* Recommendations */}
        <div className="space-y-3 mx-10 rounded-lg p-4 border border-gray-200">
        <div className="h-10 bg-gray-300 w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          <div className="h-4 bg-gray-200 rounded w-4/5"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>
    );
  };
  
  export default PolicySkeletonCard;
  